Controller.$inject = [];

function Controller() {

}

export function HuiStepSeparator() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiStepSeparator',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                 <div class="hui-step-separator">&nbsp;</div>
            `;
        }
    };
}